import styled from 'styled-components';
import { customMedia } from 'styles/utils';

export const ContentBlockWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 2rem;

  ${customMedia.lessThan('medium')`
    grid-template-columns: repeat(1, 1fr);
  `};
`;

export const ContentBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: space-between;
  width: 100%;
  min-height: 3rem;

  h5 {
    min-height: 1.5rem;
  }

  ${customMedia.lessThan('medium')`
    display: ${props => (props.empty ? 'none' : 'flex')};
    min-height: ${props => (props.empty ? '0px' : '3rem')};
  `};
`;

export const RfqId = styled.span`
  font-size: ${props => props.theme.font.size.xmedium};
  color: ${props => props.theme.color.wfGrey};
`;

export const StatusDivider = styled.span`
  margin: 0.5rem 0;
`;

export const Status = styled.span`
  font-weight: ${props => props.theme.font.weight.xbold};
  margin-right: ${props => props.theme.spacing.small};
`;

export const StatusIndicator = styled.small`
  display: inline-block;
  width: ${props => props.theme.spacing.default};
  height: ${props => props.theme.spacing.default};
  background-color: ${props =>
    props.color?.startsWith('wf')
      ? props.theme.color[props.color]
      : props.color};
  border-radius: 100%;
  margin-left: ${props => props.theme.spacing.small};
  vertical-align: middle;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${props => props.theme.color.wfGrey200};
  margin-top: ${props => (props.marginBottom ? '0' : '1rem')};
  margin-bottom: ${props => (props.marginBottom ? '1rem' : '0')};
`;

export const IncompleteRFQSectionStyled = styled.div`
  margin-top: ${props => props.theme.spacing.default};
  padding: ${props => props.theme.spacing.default};
  border: 1px solid ${props => props.theme.color.wfOrange};
  background-color: ${props => props.theme.color.wfOrange200};
`;
